import { yupResolver } from "@hookform/resolvers/yup";
import type { FC } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

import type { Experience } from "@/Dashboard/pages/ExperiencesV2/types";
import ExperienceSettings from "@/VisualBuilder/components/ExperienceSettingsDialog/ExperienceSettings";
import type { ExperienceSettingsFormValues } from "@/VisualBuilder/components/ExperienceSettingsDialog/ExperienceSettingsModal";

const settingsFormSchema = yup
  .object({
    title: yup.string().required("Required"),
    locked: yup.boolean().required("Required"),
    dbcEnabled: yup.boolean().required("Required"),
    dbcUserId: yup.number().required("Required"),
    userCollectionSync: yup.boolean().required("Required"),
    propertyInfoCardEnabled: yup.boolean().required("Required"),
  })
  .required();

interface ExperienceSettingsFormLayerProps {
  readonly experience: Experience;
  readonly open: boolean;
  readonly onCloseDialog: () => void;
  readonly propertyId: string;
  readonly userId: string;
}

const ExperienceSettingsFormLayer: FC<ExperienceSettingsFormLayerProps> = ({
  experience,
  open,
  onCloseDialog,
  propertyId,
  userId,
}: {
  experience: Experience;
  open: boolean;
  onCloseDialog: () => void;
  propertyId: string;
  userId: string;
}) => {
  const methods = useForm<ExperienceSettingsFormValues>({
    mode: "all",
    resolver: yupResolver(settingsFormSchema),
    defaultValues: {
      title: experience.title,
      locked: experience.locked,
      dbcEnabled: experience.dbcEnabled,
      dbcUserId: experience.dbcUserId ?? experience.createdBy?.id ?? undefined,
      userCollectionSync: experience.userCollectionSync,
      propertyInfoCardEnabled: experience.propertyInfoCardEnabled,
    },
  });

  return (
    <FormProvider {...methods}>
      <ExperienceSettings
        experience={experience}
        propertyId={propertyId}
        userId={userId}
        open={open}
        onCloseDialog={onCloseDialog}
      />
    </FormProvider>
  );
};

export default ExperienceSettingsFormLayer;
